__turbopack_context__.v({
  "className": "bebas_neue_fdb3bc44-module__JUCEpa__className",
});
